<template>
  <v-loading-messages :messages="messages" :showing-any-message.sync="showingAnyMessage" />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("classifier");

import VLoadingMessages from "@/components/loading/LoadingMessages.vue";

export default {
  components: {
    VLoadingMessages
  },
  data: () => ({
    showingAnyMessage: null
  }),
  computed: {
    ...mapState([
      "classifications",
      "getItemsResultMessage",
      "items",
      "loadingClassifications",
      "loadingItems"
    ]),
    loadingAnything() {
      return this.loadingClassifications || this.loadingItems;
    },
    messages() {
      return [
        {
          flag: this.loadingClassifications,
          text: "Cargando clasificaciones",
          spinner: true
        },
        {
          flag: !this.items.length && this.loadingItems,
          text: "Cargando QMIs",
          spinner: true
        },
        {
          flag: !this.loadingAnything && !this.classifications.length,
          text: "Al parecer no pudimos cargar las clasificaciones",
          spinner: false
        },
        {
          flag:
            !this.loadingAnything &&
            this.classifications.length &&
            !this.items.length,
          text:
            this.getItemsResultMessage || "No pudimos obtener las predicciones",
          spinner: false
        }
      ];
    }
  },
  watch: {
    showingAnyMessage() {
      this.$emit("update:showingAnyMessage", this.showingAnyMessage);
    }
  }
};
</script>